import React from "react";

import { Image } from "../../../common/Image";
import { IOptionValue } from "../../../models/catalogue";
import { ImageChooserBlock } from "../../../models/streamfield-blocks";

interface IProps {
    attribute: IOptionValue;
    icon: ImageChooserBlock | null;
}

export const HighlightedAttribute = ({
    attribute,
    icon,
}: IProps): React.ReactNode => {
    return (
        <>
            {icon && <Image src={icon.url} alt={""} />}
            <p className="caption">{attribute}</p>
        </>
    );
};
